export default __webpack_public_path__ + "static/media/RESTON.d9aa5369.jpg";